import Image from 'next/image'
import DefaultImage from '#/assets/images/blog/default.png'
import Link from '#/components/Link'
import cn from '#/utils/classnames'

interface CoverImageProps {
  title?: string
  coverImage: Blog.Image
  slug: string
  height?: string
}
const CoverImage: React.FC<CoverImageProps> = ({
  title,
  coverImage,
  slug,
  height
}) => {
  const image = (
    <div className='relative duration-500 ease-in-out xs:hover:-translate-y-px xs:hover:scale-105'>
      <div className='absolute z-10 h-full w-full duration-500 xs:hover:bg-black xs:hover:bg-opacity-10 xs:hover:transition-opacity' />
      <div
        className={cn(`${height} rounded-lg`, { 'w-full relative object-cover': slug })}
      >
        {coverImage?.sourceUrl ? (
          <Image
            alt={title || 'Cover'}
            className='object-cover object-center'
            fill
            quality={100}
            src={coverImage?.sourceUrl}
          />
        ) : (
          <Image
            alt='Default'
            className='object-cover'
            fill
            src={DefaultImage}
          />
        )}
      </div>
    </div>
  )

  return (
    <div className='sm:mx-0'>
      {slug ? (
        <Link href={`/blog/posts/${slug}`} legacyBehavior passHref>
          <span aria-label={title}>{image}</span>
        </Link>
      ) : (
        image
      )}
    </div>
  )
}

export default CoverImage
